import { DomainError } from '@/errors';

export class CreatePaymentTokenError extends DomainError {}
